import { render, staticRenderFns } from "./modal-tica-connect.vue?vue&type=template&id=08bdda02"
import script from "./modal-tica-connect.vue?vue&type=script&lang=js"
export * from "./modal-tica-connect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports